import axios from "axios";
import { format } from "date-fns";
import { Edit, Trash } from "iconsax-react";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import DeleteModal from "../../components/delete_modal.jsx";
import ArrayDelimiter from "../../../utils/array_delimiter.jsx";
import ProgressSpinner from "../../components/progress_spinner.jsx";
import Table from "../../components/table.jsx";
import { commonConfigs, urls } from "../../../../config.js";
import UpdateRoleAccessModal from "./components/update_role_access_modal.jsx";
// import { showSessionExpiredDialog } from "../../../commons/utils/jwt.jsx";
// import { apiInstance } from "../../../config/axios/axios.jsx";
import beveatApiStaging from "../../../api/staging_beveat_api.js";
import beveatApiProduction from "../../../api/production_beveat_api.js";
import CreateRoleAccessModal from "../../../views/configuration/roles/components/create_role_access_modal.jsx"

const RoleAccessLayout = () => {
  const [load, setLoad] = useState(false);
  const [isCreateModal, setCreateModal] = useState(false);
  const [isUpdateModal, setUpdateModal] = useState(false);
  const [isDeleteModal, setDeleteModal] = useState(false);
  const [rowToEdit, setRowToEdit] = useState();
  const [roleData, setRoleData] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  let getAccessRolesUrl = ``;
  // let getAccessRolesUrl = urls.resourceOwnerUrl;
  let deleteAccessRolesUrl = ``;
  let apiHeaders;
  let apiInstance;

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (process.env.REACT_APP_ENV === "staging") {
    getAccessRolesUrl =
      urls.baseUrl + commonConfigs.apiUrls.getAllAccessRoles();
    deleteAccessRolesUrl = urls.baseUrl;
    apiHeaders = commonConfigs.apiHeader;
    apiInstance = beveatApiStaging;
  } else {
    getAccessRolesUrl =
      urls.prodUrl +
      commonConfigs.apiUrls.getAllAccessRoles();
    deleteAccessRolesUrl = urls.prodUrl;
    apiHeaders = commonConfigs.prodApiHeader;
    apiInstance = beveatApiProduction;
  }

  async function getAccessRoles() {
    await apiInstance
      .get(getAccessRolesUrl, { headers: apiHeaders })
      // (await apiInstance(getAccessRolesUrl, apiHeaders)).get(commonConfigs.apiUrls.getAllAccessRoles())
      .then((res) => {
        // console.log(res.data.result.data);
        setRoleData(res.data.result.data);
        setLoad(false);
      })
      .catch((err) => {
        console.log('An error occurred: ', err);
      });
  }

  useEffect(() => {
    getAccessRoles();
  }, []);

  const columns = useMemo(() => [
    {
      Header: "Role Id",
      accessor: "role_id",
    },
    {
      Header: "Role Name",
      accessor: "role_name",
    },
    {
      Header: "Access Type",
      accessor: "access_rights",
      Cell: ({ row }) => {
        let accessType = [];
        if (row.original.access_rights.length > 0) {
          accessType = row.original.access_rights.map((obj) =>
            obj.access_name_option
              ? obj.access_name + " [" + obj.access_name_option + "]"
              : obj.access_name
          );
        }
        return (
          <div className="text-sm text-gray-900">
            <ArrayDelimiter data={accessType} delimiter=", " />
          </div>
        );
      },
    },
    {
      Header: "Last Updated By",
      accessor: "updated_by",
      Cell: ({ value }) => (value ? value : "-"),
    },
    {
      Header: "Last Updated On",
      accessor: "updated_on",
      Cell: ({ row }) => {
        if (row.values.updated_on) {
          row.values.updated_on = format(
            new Date(row.values.updated_on),
            "dd MMM yyyy HH:mm"
          );
          var date = row.values.updated_on;

          if (date) {
            return <div className="text-sm text-gray-900">{date}</div>;
          }
        }
        return <div className="text-sm text-gray-900">-</div>;
      },
    },
    {
      id: "edit",
      Cell: ({ row }) => {
        return (
          <div
            className="text-gray-900 flex justify-end space-x-3"
            style={{ paddingRight: isMobile ? "8px" : "15px" }}
          >
            <button
              type="button"
              onClick={() => {
                setUpdateModal(true);
                setRowToEdit(row.original);
              }}
              style={{
                minHeight: isMobile ? "44px" : undefined,
                minWidth: isMobile ? "44px" : undefined,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: isMobile ? "8px" : undefined
              }}
            >
              <Edit
                aria-hidden="true"
                className={`${isMobile ? 'w-5 h-5' : 'w-6 h-6'}`}
              />
            </button>
            <button
              type="button"
              onClick={() => {
                setDeleteModal(true);
                setRowToEdit(row.original);
              }}
              style={{
                minHeight: isMobile ? "44px" : undefined,
                minWidth: isMobile ? "44px" : undefined,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: isMobile ? "8px" : undefined
              }}
            >
              <Trash
                aria-hidden="true"
                className={`${isMobile ? 'w-5 h-5' : 'w-6 h-6'}`}
              />
            </button>
          </div>
        );
      },
    },
  ]);

  if (!load) {
    return (
      <div className="w-full bg-gray-100 min-h-screen">
        {/* Add mobile-specific CSS */}
        {isMobile && (
          <style>
            {`
              @media (max-width: 768px) {
                .table-container .flex.justify-between.items-center {
                  flex-direction: column !important;
                  align-items: center !important;
                  gap: 12px !important;
                }
                .table-container .flex.justify-between.items-center > div:first-child {
                  width: 100% !important;
                  text-align: center !important;
                }
                .table-container .flex.justify-between.items-center > div:last-child {
                  width: 100% !important;
                }
                .table-container h2 {
                  margin-bottom: 0 !important;
                  white-space: normal !important;
                  word-break: break-word !important;
                  text-align: center !important;
                }
              }
            `}
          </style>
        )}

        <div className={`${isMobile ? 'p-4' : 'p-6'}`}>
          {/* Header Section */}
          <div className={`${isMobile ? 'mb-6 mt-2' : 'flex justify-end items-center mb-12 mt-2'}`}>
            {/* Mobile Title */}
            {isMobile && (
              <div className="text-center mb-4">
                <h2
                  className="font-bold text-gray-900"
                  style={{
                    fontSize: "20px",
                    marginBottom: "0",
                    lineHeight: "1.3"
                  }}
                >
                  Access Roles
                </h2>
              </div>
            )}

            {/* Create Button */}
            <div className={isMobile ? 'text-center' : ''}>
                <button
                  type="button"
                  onClick={() => setCreateModal(true)} // Opens the modal
                  className="hover:bg-blue-500 text-blue-500 hover:text-white outline outline-blue-500 font-bold py-2 px-12 rounded-full"
                  style={{
                    fontSize: isMobile ? "16px" : undefined,
                    padding: isMobile ? "12px 24px" : undefined,
                    minHeight: isMobile ? "44px" : undefined,
                    width: isMobile ? "100%" : undefined,
                    maxWidth: isMobile ? "300px" : undefined
                  }}
                >
                  Create Role Access
                </button>
              {/* </Link> */}
            </div>
          </div>

          {/* Table Section */}
          {roleData != null ? (
            <div
              className="table-container"
              style={{
                overflowX: isMobile ? "auto" : "visible",
                marginBottom: isMobile ? "20px" : undefined,
                WebkitOverflowScrolling: isMobile ? "touch" : undefined
              }}
            >
              <Table
                columns={columns}
                data={roleData}
                title="All Roles"
                filters={columns.map((column) => column.accessor)}
              />
            </div>
          ) : (
            <div className={`${isMobile ? 'w-full h-96' : 'w-screen h-screen'} flex flex-wrap flex-row place-items-center`}>
              <div className="flex place-content-center w-full">
                <div className="text-center">
                  <ProgressSpinner className={`${isMobile ? 'w-12 h-12' : 'w-20 h-20'}`} />
                  {isMobile && (
                    <p className="mt-4 text-gray-600 text-sm">
                      Loading role access...
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Modals */}
          {isCreateModal && (
            <CreateRoleAccessModal
              setOpenModal={setCreateModal}
              refreshData={getAccessRoles}
            />
          )}
          {isUpdateModal && (
            <UpdateRoleAccessModal
              setOpenModal={setUpdateModal}
              load={setLoad}
              row={rowToEdit}
            />
          )}
          {isDeleteModal && (
            <DeleteModal
              setDeleteModal={setDeleteModal}
              load={getAccessRoles}
              url={deleteAccessRolesUrl + commonConfigs.apiUrls.deleteAccessRole(rowToEdit.role_id)}
            />
          )}
        </div>
      </div>
    );
  }

  // Mobile-friendly loading state
  return (
    <div className="w-full bg-gray-100 min-h-screen">
      <div className="flex items-center justify-center" style={{ minHeight: "50vh" }}>
        <div className="text-center p-8">
          <div className={`animate-spin rounded-full border-4 border-blue-200 border-t-blue-600 mx-auto mb-4 ${isMobile ? 'h-12 w-12' : 'h-16 w-16'
            }`}></div>
          <h3 className={`font-medium text-gray-900 ${isMobile ? 'text-lg' : 'text-xl'}`}>
            Loading Role Access
          </h3>
          <p className={`text-gray-600 ${isMobile ? 'text-sm' : 'text-base'}`}>
            Please wait while we fetch the role data...
          </p>
        </div>
      </div>
    </div>
  );
};

export default RoleAccessLayout;